import React, { Component } from 'react';
import ProgressPopoverClass from '../ProgressPopoverClass';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import cn from 'classnames';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';
import AssignButton from './AssignButton';
import { UNITS as COPY } from 'chameleon/ui-stack/utilities/copy';
import { sendTelemetryEvent } from 'chameleon/ui-stack/ui/units/subunit-content/ppc';

import './index.scss';
import { withPerformanceTier } from 'chameleon/src/hooks/usePerformanceTiers';

/**
 * Draws progress popover content
 * */
class ProgressPopoverContent extends Component {
  static displayName = 'ProgressPopoverContent';

  render() {
    const {
      assignments,
      subjectId,
      showAttestationConfirmationDialog,
      rawAssignments,
      scope,
      subunitType = SubunitAssessmentTypes.PPC,
      displayName,
      disablePpcAutoAssignFlag,
      unitNumber,
      unitTitle,
      assessmentId,
      isPPC,
      performanceTiers,
    } = this.props;
    const sortedByClass = assignments.sort((a, b) => {
      if (a.sectionName.toUpperCase() > b.sectionName.toUpperCase()) {
        return 1;
      }
      if (a.sectionName.toUpperCase() < b.sectionName.toUpperCase()) {
        return -1;
      }
      return 0;
    });

    const showAssignButton =
      subunitType === SubunitAssessmentTypes.PE ||
      subunitType === SubunitAssessmentTypes.SPP ||
      (subunitType === SubunitAssessmentTypes.PPC && disablePpcAutoAssignFlag);

    const getAssignItemTitle = () => {
      if (subunitType === SubunitAssessmentTypes.PPC) {
        return COPY.ASSIGN.MODAL_TITLE(
          unitNumber,
          displayName,
          false,
          unitTitle,
        );
      }
      return displayName;
    };

    const currentAssignment = sortedByClass[0] || {
      assessment: {
        id: assessmentId,
      },
    };
    return (
      <div className="progress-popover rounded-2xl">
        <div className="flex flex-row justify-between border-b border-gray-300">
          <div className="text-2xl font-bold text-black text-left p-4 flex flex-1">
            <span
              className={cn('header', {
                '--smaller': subunitType === SubunitAssessmentTypes.SPP,
              })}
            >
              {HEADERS[subunitType] || sortedByClass[0].title}
            </span>
            <span aria-hidden>Assigned on</span>
          </div>
        </div>
        <div className="results divide-y divide-gray-300 flex flex-col">
          {sortedByClass.map((assignment, index) => (
            <ProgressPopoverClass
              data-test-progress-popover-class
              assignment={assignment}
              assignments={assignments}
              subjectId={subjectId}
              isFirst={index === 0}
              key={assignment.id}
              performanceTiers={performanceTiers}
              showAttestationConfirmationDialog={
                showAttestationConfirmationDialog
              }
              rawAssignments={rawAssignments}
              scope={scope}
              subunitType={subunitType}
            />
          ))}

          {/* for PEs, PPCs and SPPs show the assign button */}
          {showAssignButton && (
            <div className="flex flex-row-reverse py-4 mr-4">
              <AssignButton
                isSPP={subunitType === SubunitAssessmentTypes.SPP}
                isPPC={isPPC}
                assignment={currentAssignment}
                showAttestationConfirmationDialog={
                  showAttestationConfirmationDialog
                }
                displayName={displayName}
                scope={scope}
                itemTitle={getAssignItemTitle()}
                onAssignCallback={(totalAssignees, assessmentTitle) => {
                  sendTelemetryEvent(
                    subjectId,
                    totalAssignees.length,
                    assessmentId,
                    assessmentTitle,
                  );
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const HEADERS = {
  PPC: 'Progress Check (All Progress)',
  PE: 'Practice Exam (All Progress)',
  LC: 'Learning Checkpoint (All Progress)',
  PT: 'Performance Task (All Progress)',
};

export default compose(
  connect(({ featureFlag, subject }) => ({
    showAttestationConfirmationDialog:
      featureFlag.show_attestation_confirmation_dialog,
    disablePpcAutoAssignFlag: featureFlag.disable_ppc_auto_assign,
    isPreApSubject: subject.data.isPreApSubject,
    subjectId: subject.data.id,
  })),
  withPerformanceTier,
)(ProgressPopoverContent);
